import { render, staticRenderFns } from "./PublicationsNav.vue?vue&type=template&id=71f00f2f&"
import script from "./PublicationsNav.vue?vue&type=script&lang=js&"
export * from "./PublicationsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports